import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  savedValue: null,
  expiryDate: null,
};

// Create a slice
const valueSlice = createSlice({
  name: 'value',
  initialState,
  reducers: {
    saveValue: (state, action) => {
      state.savedValue = action.payload;
    },
    setExpiry: (state, action) => {
      state.expiryDate = action.payload;
    },
  },
});

// Export the action creator
export const { saveValue, setExpiry } = valueSlice.actions;
export default valueSlice.reducer;
